import React from 'react'

import ExternalLink from '@/components/misc/ExternalLink'
import CopyLink from '@/components/misc/PanelInviteEmailTemplate/CopyLink'
import { Input } from '@/components/ui/input'
import useCurrentCompanyOrFail from '@/hooks/useCurrentCompanyOrFail'

const CompanyClientReferralsLink: React.FC = () => {
  const currentCompany = useCurrentCompanyOrFail()
  const referAFriendLink = currentCompany.recommendationUrl

  return (
    <div className="flex flex-wrap items-center gap-2 max-w-175">
      <span className="font-medium">Your firm's recommendation link:</span>
      <Input
        type="text"
        className="bg-slate-50 w-auto min-w-25 grow"
        readOnly
        value={referAFriendLink}
      />

      <CopyLink
        buttonText="Copy link"
        textToCopy={referAFriendLink}
        size="sm"
        className="mr-2 shrink-0 text-xs"
      />

      <ExternalLink
        className="text-black gap-1.5 text-xs"
        href={referAFriendLink}
      >
        Preview
      </ExternalLink>
    </div>
  )
}

export default CompanyClientReferralsLink
